import { render } from "./BankCard.vue?vue&type=template&id=12e8b12f&scoped=true"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"

import "./BankCard.vue?vue&type=style&index=0&id=12e8b12f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e8b12f"]])

export default __exports__